import type { BookingType } from '@jupi/shared'

// One icon per booking type, everywhere a booking is shown. Whole `mdi:`
// literals, because the icon bundler only finds names it can read.
export const BOOKING_TYPE_ICONS: Record<BookingType, string> = {
  private: 'mdi:airplane',
  training: 'mdi:school',
  maintenance: 'mdi:wrench',
}

// The type a booking row carries, for rows from before the API sent it.
export const typeOf = (booking: { bookingType?: BookingType; isMaintenance: boolean }): BookingType =>
  booking.bookingType ?? (booking.isMaintenance ? 'maintenance' : 'private')
